/* Auto External Links Code Start*/

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if ((links[i].href.indexOf("tel:") <= -1) && (links[i].href.indexOf("mailto") <= -1) && (links[i].hostname !== window.location.hostname)) {
    links[i].target = '_blank';
  }
}

/* Auto External Links Code End*/

/* Inactive Tab Message Code Start */

/* var newTitle = '👉 Don\'t forget this...'; 
var oldTitle = document.title;

window.onblur = function () {
    document.title = newTitle;
};

window.onfocus = function () {
    document.title = oldTitle;
};*/

/* Inactive Tab Message Code End */

/* Back To Top Button Code Start */

jQuery(document).ready(function()
{
  var offset = 300;
  var duration = 500;
  
  $(window).scroll(function() {
    var wintop = $(window).scrollTop(), docheight = $(document).height(), winheight = $(window).height();
    var scroll_per = (wintop/(docheight-winheight))*100;
    if ($(this).scrollTop() > offset) {
      $('.back-to-top-btn').fadeIn(duration);
      $('.animate_bg_arrow_fill').css('height',scroll_per+'%');
    } 
    else {
      $('.back-to-top-btn').fadeOut(duration);
    }
  });
  
  $('.back-to-top-btn').unbind('click.smoothscroll').bind('click', function(e) {
    e.preventDefault();
    $('html, body').animate( { scrollTop: 0 }, duration);
    return false;
  })
  
});

/* Back To Top Button Code End */

/* Favicon Cart Count Code End */
jQuery(document).ready(function()
{
  if(parseInt(jQuery(".cart_count:first").text()) > 0)
  {
    var favicon=new Favico({
        animation:'slide',
        position : 'up'
    });
  	favicon.badge(jQuery(".cart_count:first").text());
  }
});

/* Favicon Cart Count Code End */

/* Custom Announcement Bar Code Start */

	
jQuery(document).ready(function()
{
	const custom_top_bar = window.Cookies.get('custom_top_bar');  
 	if (custom_top_bar !== 'close_top_bar') {
        var announ_txt = "<span><span>Free UK & US Shipping • Limited Time</span><span>Christmas Gifting Is Open</span><span>Proof Before Print</span></span>" ;
    announ_txt = announ_txt.replace("[TIMER]", "<timer id='countdown-container'><timer class='time-group'><timer id='hours' class='time-box'>--</timer><timer class='count_label'>Hours</timer></timer><timer class='time-group'><timer id='minutes' class='time-box'>--</timer><timer class='count_label'>Min</timer></timer><timer class='time-group'><timer id='seconds' class='time-box'>--</timer><timer class='count_label'>Sec</timer></timer></timer>");
        jQuery("body").prepend("<div id='custom_top_announce_bar'><div id='custom_top_announce_txt'><div>"+announ_txt+"</div><button class='close_top_custom_bar'>✕</button> </div> </div>");
      	jQuery("body").css('padding-top',$("#custom_top_announce_bar").height()+'px');
      jQuery("#custom_top_announce_bar").css('background-color','#F5EDE8');
      jQuery("#custom_top_announce_bar").css('color','#1f2a3c');

      // SITE26-032: keep the first announcement visible until the page fully loads.
      // CSS holds it for two more seconds before scrolling from its beginning.
      function startTopAnnouncement() {
        var bar = document.getElementById('custom_top_announce_bar');
        if (bar) bar.classList.add('pg-announcement-running');
      }
      if (document.readyState === 'complete') {
        startTopAnnouncement();
      } else {
        window.addEventListener('load', startTopAnnouncement, { once: true });
      }
    }
 
	$('.close_top_custom_bar').on('click', function(){
      $('#custom_top_announce_bar').remove();
      $('body').css('padding-top','0px');
      window.Cookies.set('custom_top_bar', 'close_top_bar', {
        expires: 30, path: '', domain: '', sameSite: 'None', secure: true,
      });
    });
});    
	


/* Custom Announcement Bar Code End */

  
/* Custom Cart timer Code Start */


/* Custom Cart timer Code End */

/* Custom Cart Delivery Date Start */

if($('form#cart_form').length){
  setInterval(() => {
    const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];

    let artwork_time = parseInt("48");
    let shipping_total_time = parseInt("84");
    let countdown_text_artwork = "YOUR ARTWORK will be ready by [DATE] if you order in the next [TIME]";
    let countdown_text_line = "Express Shipping order will arrive by [DATE] if you order in the next [TIME] in UK";

    const today = new Date();
    const nowHour = today.getUTCHours();
    const cutOff_time = new Date();
    let deliver_date;
    let left_time;
    if(nowHour < 14) {
      cutOff_time.setUTCHours(14, 0, 0, 0);
      left_time = cutOff_time - today;
      artwork_date = today.setUTCHours(today.getUTCHours() + artwork_time)
      deliver_date = today.setUTCHours(today.getUTCHours() + shipping_total_time)
    } else {
      cutOff_time.setUTCDate(new Date(today).getUTCDate() + 1);
      cutOff_time.setUTCHours(0, 0, 0, 0);
      left_time = cutOff_time - today;
      let tomorrow = new Date(today);
      tomorrow.setUTCDate(today.getUTCDate() + 1);
      artwork_date = tomorrow.setUTCHours(tomorrow.getUTCHours() + artwork_time)
      deliver_date = tomorrow.setUTCHours(tomorrow.getUTCHours() + shipping_total_time)
    }

    let day = new Date(deliver_date).getUTCDay();
    const date = new Date(deliver_date).getUTCDate();
    const month = new Date(deliver_date).getUTCMonth();
    const year = new Date(deliver_date).getUTCFullYear();

    const hours = Math.floor(left_time % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
    const minutes = Math.floor(left_time % (1000 * 60 * 60) / (1000 * 60));

    countdown_text = countdown_text_line.replace("[DATE]", `<strong> ${DAYS[day]}, ${date} ${MONTHS[month]} ${year} </strong>`);
    countdown_text = countdown_text.replace("[TIME]", `<strong> ${("00" + hours).slice(2)} hours ${("00" + minutes).slice(2)} mins</strong>`);

    document.querySelector(".countdown_shipping_text").innerHTML = countdown_text;

    let artwork_date_day = new Date(artwork_date).getUTCDay();
    const artwork_date_date = new Date(artwork_date).getUTCDate();
    const artwork_date_month = new Date(artwork_date).getUTCMonth();
    const artwork_date_year = new Date(artwork_date).getUTCFullYear();

    const artwork_date_hours = Math.floor(left_time % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
    const artwork_date_minutes = Math.floor(left_time % (1000 * 60 * 60) / (1000 * 60));

    countdown_artwork_text = countdown_text_artwork.replace("[DATE]", `<strong> ${DAYS[artwork_date_day]}, ${artwork_date_date} ${MONTHS[artwork_date_month]} ${artwork_date_year} </strong>`);
    countdown_artwork_text = countdown_artwork_text.replace("[TIME]", `<strong> ${("00" + artwork_date_hours).slice(2)} hours ${("00" + artwork_date_minutes).slice(2)} mins</strong>`);

    document.querySelector(".countdown_artwork_text").innerHTML = countdown_artwork_text;
    
  },1000);

    var Swipes_cart = new Swiper('.countdown_cart_slider', {
    speed:1000,
    autoplay:true,
    autoplay: {
      delay: 4000,
    },
    slidesPerView:1,
    spaceBetween: 40
    });

  setTimeout(function(){ $('.countdown_shipping_text_sec').show(); },1000);
}

/* Custom Cart Delivery Date End */

/* Custom Get it By Timer Product page start */




jQuery(document).ready(function()
{ 
  setTimeout(function(){
    $("#smile-ui-lite-container").css('z-index','99');  
  },2000);
});
/* Custom Get it By Timer Product page end */

jQuery(document).ready(function()
{
    /*setTimeout(function(){
      if(jQuery('.next_step_btn').length)
      {
        jQuery('.purchase-details__buttons .add_to_cart ').hide();
        jQuery('.purchase-details__buttons .shopify-payment-button ').hide();
      }
    },2000);*/
  
    jQuery('.next_step_btn').click(function(){
        jQuery('.back_step_btn').show();
        jQuery('.step-process-box').removeClass('active');
        jQuery('.step-process-box').each(function(index,obj){
            jQuery(this).addClass('active');
            jQuery('.swatch_options > div').css('height','0').css('opacity','0').css('position','relative').css('z-index','-111');
            if(jQuery(this).hasClass('current'))
            {
              jQuery(this).addClass('active');
              var position = jQuery(this).next().data('position');
              jQuery('.swatch_options > div:nth-child('+position+')').css('height','auto').css('opacity','1').css('position','inherit');
              jQuery(this).removeClass('current');
              jQuery(this).next().addClass('current');
              if(position > 0)
              {
                jQuery('.uploadkit').hide();
              }
              return false;
            }
        });
        if(jQuery('.step-process-box').last().hasClass('current'))
        {
            jQuery('.next_step_btn').hide();
            /*jQuery('.purchase-details__buttons .add_to_cart ').show();
            jQuery('.purchase-details__buttons .shopify-payment-button ').show();*/
        }
    });

    jQuery('.back_step_btn').click(function(){
          jQuery('.next_step_btn').show();
          /*jQuery('.purchase-details__buttons .add_to_cart ').hide();
          jQuery('.purchase-details__buttons .shopify-payment-button ').hide();*/
          jQuery('.step-process-box').each(function(index,obj){
            jQuery('.swatch_options > div').css('height','0').css('opacity','0').css('position','relative').css('z-index','-111');
              if(jQuery(this).hasClass('current'))
              {
                  jQuery(this).removeClass('current');
                  jQuery(this).prev().addClass('current');
                  var position = jQuery(this).prev().data('position');
                  jQuery('.swatch_options > div:nth-child('+position+')').css('height','auto').css('opacity','1').css('position','inherit');
                  if(position == 0)
                  {
                    jQuery('.uploadkit').show();
                  }
                  jQuery(this).prev().removeClass('active');
                  return false;
              }
          });
        if(jQuery('.step-process-box').first().hasClass('current'))
        {
            jQuery('.back_step_btn').hide();
        }
    });

    /* Top text Slider START */
    var announce_slide = new Swiper('.swiper_announce', {
        slidesPerView: 4,
        centeredSlides: false,
        navigation: {
            nextEl: '.swiper_announce .swiper-button-next',
            prevEl: '.swiper_announce .swiper-button-prev',
        },
        breakpoints: {
            1024: {
                slidesPerView: 1,
                centeredSlides: false,
            },
        },
    });
  /* Top text Slider End */

    /* CountDown Timer START */
  if ($("#hours").length) {
    const COUNTDOWN_DURATION = 14 * 60 * 60 * 1000; // 14 hours
    const COOKIE_NAME = 'visitorCountdownStart';

    function getCookie(name) {
      const matches = document.cookie.match(
        new RegExp("(?:^|; )" + name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1") + "=([^;]*)")
      );
      return matches ? decodeURIComponent(matches[1]) : null;
    }

    function setCookie(name, value) {
      document.cookie = `${name}=${encodeURIComponent(value)}; path=/`;
    }

    function initializeCountdown() {
      let startTime = getCookie(COOKIE_NAME);
      const now = Date.now();

      if (!startTime) {
        startTime = now;
        setCookie(COOKIE_NAME, startTime);
      }

      function updateTimer() {
        const now = Date.now();
        let timeLeft = COUNTDOWN_DURATION - (now - startTime);

        if (timeLeft <= 0) {
          // reset every 14 hours
          startTime = Date.now();
          setCookie(COOKIE_NAME, startTime);
          timeLeft = COUNTDOWN_DURATION;
        }

        const hours = Math.floor(timeLeft / (1000 * 60 * 60));
        const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

        document.getElementById("hours").innerText = String(hours).padStart(2, "0");
        document.getElementById("minutes").innerText = String(minutes).padStart(2, "0");
        document.getElementById("seconds").innerText = String(seconds).padStart(2, "0");
      }

      updateTimer();
      setInterval(updateTimer, 1000);
    }

    initializeCountdown();
  }
 /* CountDown Timer END */
  
});